// Пульт правил: чистые помощники для экрана (форматы, варианты значений, тексты ошибок).

const STATUS_TONES = { live: 'live', planned: 'planned', fixed: 'fixed' }

export function statusTone(status) {
  return STATUS_TONES[status] || 'fixed'
}

function pad(n) {
  return String(n).padStart(2, '0')
}

// Дата изменения — по времени пользователя (Ульяновск для офиса): «01.11 21:40».
export function formatChangedAt(value) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return ''
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

// Для правил «час дня» — список 00:00…23:00 в допустимых границах; для остальных — поле числа.
export function hourOptions(rule) {
  if (!rule || rule.unit !== 'hour') return []
  const out = []
  for (let h = rule.minimum ?? 0; h <= (rule.maximum ?? 23); h += 1) {
    out.push({ value: h, label: `${pad(h)}:00` })
  }
  return out
}

export function rangeHint(rule) {
  if (!rule) return ''
  if (rule.unit === 'hour') return `от ${pad(rule.minimum)}:00 до ${pad(rule.maximum)}:00`
  return `от ${rule.minimum} до ${rule.maximum} ${rule.unit_title || ''}`.trim()
}

// Что отправить на сервер и что сказать человеку, если ввод не годится (до запроса).
export function prepareChange(rule, rawValue, comment) {
  const reason = String(comment || '').trim()
  if (reason.length < 3) return { error: 'Напишите, почему меняете правило — это попадёт в историю' }
  const text = String(rawValue ?? '').trim()
  if (text === '') return { error: 'Укажите новое значение' }
  const value = Number(text)
  if (!Number.isInteger(value)) return { error: 'Нужно целое число' }
  if (value < rule.minimum || value > rule.maximum) return { error: `Допустимо ${rangeHint(rule)}` }
  if (value === rule.value) return { error: 'Значение не изменилось' }
  return { value, comment: reason }
}

export function errorText(error) {
  const detail = error?.response?.data?.detail
  if (typeof detail === 'string' && detail) return detail
  return error?.message || 'Не получилось сохранить. Повторите через минуту.'
}

export function countRules(groups = []) {
  return groups.reduce((sum, g) => sum + (g.rules?.length || 0), 0)
}

// Мгновенный поиск по правилам: слова запроса ищутся в названии, описании, «где действует»
// и значении; регистр и «ё» не важны. Возвращает группы только с найденными правилами.
export function normalize(text) {
  return String(text ?? '').toLowerCase().replace(/ё/g, 'е')
}

export function filterRules(groups = [], query = '') {
  const words = normalize(query).split(/\s+/).filter(Boolean)
  if (!words.length) return groups
  return groups
    .map((group) => ({
      ...group,
      rules: (group.rules || []).filter((rule) => {
        const hay = normalize([group.title, rule.title, rule.description, rule.where, rule.value_text,
          rule.status_title].join(' '))
        return words.every((w) => hay.includes(w))
      }),
    }))
    .filter((group) => group.rules.length)
}
